<template>
  <div id='order'>
        <NavTop title='确认发货' :islink='true' linkurl='/index'/>
        <van-cell-group inset>
                    <van-cell is-link to="/addresslist/fhorder" title-class="address_title" value-class="address_label" v-if='isSetAddr'>
                        <template #title>
                            <van-icon name="location-o" /><span class='address_con'>{{choosedAddr.province}}{{choosedAddr.city}}{{choosedAddr.county}}{{choosedAddr.addressdetail}}</span>
                        </template>
                        <template #label>
                            {{choosedAddr.name}} {{choosedAddr.tel}}
                        </template>        
                    </van-cell>
                    <van-cell is-link to="/addresslist/fhorder" title-class="address_empty" value-class="address_label" v-else>
                        <template #title>
                            <van-icon name="add-o"  size="0.6rem" /><span class='address_add'>添加邮寄地址</span>
                        </template>     
                    </van-cell>
        </van-cell-group>  
        <van-cell-group inset>
           <van-cell>
               <template #title>
                  <div class='goodsitem'>
                        <div class='cellitem' v-for='item in fahuolist' :key='item.id'>
                              <div class='goodsimg'><img :src='item.headimg'/></div>
                              <div class='info'>
                                  <div class="info-line">{{item.name}}</div>
                                  <div class="info-line-small">{{item.intro}}</div>
                                  <div class="info-line"></div>
                                  <div class="info-line-bottom">
                                     <div class="info-line-bottom-left"></div>
                                     <div class="info-line-bottom-right">X{{item.nums}}</div>
                                  </div>
                              </div>
                        </div>    
                  </div>  
                  <div class='cellitem'>
                    <div class='celltitle'>运费</div>
                    <div class='cellright' v-if="freight>0">¥{{freight}}</div><div class='cellright' v-else>¥0</div>
                  </div> 
               </template>   
           </van-cell> 
        </van-cell-group> 
        <div class="bottomcon">
            <div class="bottomcon-orderbtn">
                <div class="bottomcon-orderbtn-words" @click="doFahuo">确认发货</div>
            </div>
        </div>
        <van-dialog v-model="showPswDiag" title="发货确认" show-cancel-button  :beforeClose="saveData">
          <van-cell-group>
               <van-field v-model="password" label="密码" placeholder="请输入登陆密码" type="password"/>
          </van-cell-group>
        </van-dialog>     
  </div>
</template>
<script>
import { SubmitBar,Cell, CellGroup,Icon,Dialog,Field } from 'vant';
import NavTop from '@/components/navtop'

export default {
   name: 'order',
   data() {
      return {
          processing:false,
          showPswDiag:false,
          password:''
      }
   }, 
   computed:{
      isSetAddr(){
          return Object.keys(this.$store.state.address.choosedaddress).length===0 ? false :true
      },
      choosedAddr(){
          return this.$store.state.address.choosedaddress
      },
      fahuototal(){
          return this.$store.getters.fahuototalnums(this.$store.state.fahuo.clicked)
      },
      fahuolist(){
          return this.$store.state.fahuo.fahuolist
      },
      freight(){
          return this.$store.state.fahuo.yunfei
      }
   },
   created(){
      this.getList()
   },
   methods: {
      getList(){ 
           if(!this.isSetAddr){
                    this.$post("/address/getDefaultAddr",{}).then((data)=>{
                    if(data.result.success) { 
                        this.$store.commit("SET_ADDRESS",{address:data.result.info})
                        this.setFreight()
                    }
              })
           }
           this.setFreight()
      },
      setFreight(){
          if(this.isSetAddr){
            this.$post("/order/getFreight",{goodslist:this.$store.state.fahuo.fahuolist,address:this.choosedAddr}).then((data)=>{
                    if(data.result.success){
                        this.$store.commit("SET_YUNFEI",{yunfei:data.result.info})
                    }else{
                        this.$toast(data.result.info);
                        return false;
                    }
            })
          }
      },
      onSubmit(){
            if(this.processing){
                this.$toast("请耐心等待提交完成");
                return false;
            }
            let fahuoinfo={}
            fahuoinfo["freight"]=this.$store.state.fahuo.yunfei
            fahuoinfo['goodslist']=this.$store.state.fahuo.fahuolist
            fahuoinfo["addressinfo"]=this.$store.state.address.choosedaddress
            this.processing=true
            this.$post("/fahuo/doSelFahuo",{fahuoinfo:fahuoinfo}).then((data)=>{
                if(data.result.success){ 
                    if(this.freight>0){
                        this.$go("/paymentyf/"+data.result.info);
                    }else{
                        this.$toast("发货成功")
                        this.$go("/fahuo")
                    }
                }else{
                    this.$toast(data.result.info)
                }
                this.processing=false
            })
            
      },
      doFahuo(){
         this.showPswDiag=true
      },
      saveData(action,done){
          if(action=='cancel'){
               this.clearData()
               done()
               return false
          }
          if(!this.isSetAddr){
                this.$toast("请先设置收货地址");
                return false;
          }
          if(this.password==null || this.password==''){
               this.$toast("请先输入密码");
               done(false);
               return false
          }
          this.$post("/fahuo/checkPsw",{password:this.password}).then((data)=>{
               if(data.result.success){
                   this.onSubmit()
               }else{
                   this.$toast(data.result.info)
               }
               this.clearData()
               this.getList()
               done()
          })
         
      },
      clearData(){
         this.password=''
      }
   },
   components: {
        [SubmitBar.name]: SubmitBar ,
        [Cell.name]: Cell ,
        [CellGroup.name]: CellGroup ,
        [Icon.name]: Icon ,
        [Dialog.Component.name]:Dialog.Component,
        [Field.name]:Field,
        NavTop
   }
}
</script>
<style scoped>
#order{background-color:#F6F6F6;min-height: 100vh;padding-bottom: 85px;}
.address_title{flex:4;text-align: left;}
.address_value{flex:1;}
.address_title_short{flex:2;text-align: left;}
.address_value_long{flex:4;}
.address_empty{display: flex;align-items: center;}
.address_add{padding-left:0.2rem;}
.address_con{margin-left:0.1rem;}
.title{color:#cccccc;text-align: left;}
.goodsitem{display: flex;flex-direction: column;}
.goodsimg{width:3.5rem;}
.goodsimg img{width:100%;}
.info{margin-left: 0.3rem;width:100%;display: flex;flex-flow: column nowrap;}
.info-line{font-size:0.3rem;text-align: left;}
.info-line-small{font-size:0.15rem;text-align: left;}
.info-line-bottom{display: flex;}
.info-line-bottom-left{font-size:0.25rem}
.info-line-bottom-right{margin-left: auto;}
.cellitem{display: flex;flex-direction: row;margin-top: 0.15rem;}
.line{display: flex;flex-direction: row;}
.price{margin-left:auto;font-size:0.35rem;}
.dashprice{margin-left:auto;color:#cccccc;text-decoration: line-through;font-size:0.3rem;}
.cellright{margin-left:auto;color:#969799}
.subprice{color:#bbbbbb;font-size:0.3rem;}
.goodstitle{font-size:0.35rem;font-weight: 600;}
::v-deep .van-cell-group--inset{margin-top: 0.3rem;}
::v-deep .van-field__label{width:auto!important;}
.bottomcon{display: flex;width:100%;height: 46px;position: fixed;left:0;bottom: 0;align-items: center;justify-content: center;}
.bottomcon-left{display: flex;padding-left: 0.5rem;}
.goodswords{color:#333;font-size:0.35rem}
.bottomcon-right{margin-left: auto;padding-right: 0.3rem;}
.bottomcon-orderbtn{background-color:#ee0a24;color:#fff;height:46px;width:100%;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;}
.bottomcon-orderbtn-words{font-size:0.35rem;}
</style>